import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
export let Notify = (message) => {};
export let Error = (message) => {};

const useStyles = makeStyles({
  notification: {
    direction: "rtl",
    fontFamily: "FA_IRANSans",
    top: 330,
    boxShadow: "0px 0px 20px 0px #cdcdcd7a",
    background: "linear-gradient(to right,#35C974,#8e2de2)",
  },
});

export default function NotificationManager() {
  const classes = useStyles();
  const [message, setMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [type, setType] = React.useState("info");
  const [duration, setDuration] = React.useState(0);

  const handleClose = (_) => setOpen(false);

  React.useEffect((_) => {
    Notify = (type, message, duration = 3000) => {
      setMessage(message);
      setType(type);
      setDuration(duration);
      setOpen(true);
    };
  }, []);

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}
        message={message}
        ContentProps={{ className: clsx(classes.notification, type) }}
      />
    </>
  );
}
